var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-6 py-4",domProps:{"innerHTML":_vm._s(_vm.privacyPolicy)}})}
var staticRenderFns = []

export { render, staticRenderFns }